(function () {
    'use strict';

    angular
        .module('editorApp')
        .controller('BoxCopyController', BoxCopyController);

    BoxCopyController.$inject = ['$scope', 'Category', '$uibModalInstance', 'MessageService','$translate'];

    function BoxCopyController( $scope, Category, $uibModalInstance, MessageService,$translate) {

        var vm = this;

        vm.clear = clear;
        vm.save = save;
        vm.types = [
            {name: $translate.instant("editorMessage.startWithTheCurrentPage"), page: 'this'},
            {name: $translate.instant("editorMessage.startWithTheFirstPage"), page: 'first'}
        ];

        vm.data={
            range:'this',
            generLoc:'all'
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.validate = function () {
            console.log(vm.data)
            if (vm.data.range == null || vm.data.range == "") {
                MessageService.error($translate.instant("editorMessage.pleaseSelectRange"));
                return false;
            }
            if (vm.data.generLoc == null || vm.data.generLoc == "") {
                MessageService.error($translate.instant("editorMessage.selectABuildLocation"));
                return false;
            }
            return true;
        };

        function save() {
            if (!$scope.validate()) {
                return;
            }
            onSaveSuccess(vm.data);
        }


        function onSaveSuccess(result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }

})();
